import { CustomerStore } from '@/hooks/use-customer/store'

//fields
export const emailSelector = (state: CustomerStore) => state.customer.email
export const dninieSelector = (state: CustomerStore) => state.customer.dninie
export const provinceSelector = (state: CustomerStore) =>
  state.customer.province
export const customerSelector = (state: CustomerStore) => state.customer
export const addressSelector = (state: CustomerStore) => state.address

//sets
export const setEmailSelector = (state: CustomerStore) => state.setEmail
export const setCustomerSelector = (state: CustomerStore) => state.setCustomer
export const setDninieSelector = (state: CustomerStore) => state.setDninie
export const setProvinceSelector = (state: CustomerStore) => state.setProvince
export const setAddressSelector = (state: CustomerStore) => state.setAddress
export const resetCustomerSelector = (state: CustomerStore) => state.reset
